import { render } from "./ProfileEditAuth.vue?vue&type=template&id=414f2fee"
import script from "./ProfileEditAuth.vue?vue&type=script&lang=js"
export * from "./ProfileEditAuth.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\SanttuLehtinen\\Projektit\\vetera\\vetera-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__